// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  SimulationBankStatus,
  SimulationBankStatusT,
  verifySimulationBankStatus,
} from "./simulation-bank-status";
import { SimulationRunState } from "./simulation-run-state";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A simulation run.
 */
export class SimulationRun implements flatbuffers.IUnpackableObject<SimulationRunT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationRun {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationRun(bb: flatbuffers.ByteBuffer, obj?: SimulationRun): SimulationRun {
    return (obj || new SimulationRun()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSimulationRun(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationRun,
  ): SimulationRun {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationRun()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  scenarioId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  state(): SimulationRunState {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SimulationRunState.PENDING;
  }

  /**
   * RFC 3339.
   */
  startedAt(): string | null;
  startedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  startedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  stoppedAt(): string | null;
  stoppedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  stoppedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  startedBy(): string | null;
  startedBy(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  startedBy(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * True while the run's tunnel session is up.
   */
  tunnelConnected(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  banks(index: number, obj?: SimulationBankStatus): SimulationBankStatus | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new SimulationBankStatus()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  banksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  lastError(): string | null;
  lastError(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  lastError(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startSimulationRun(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addScenarioId(builder: flatbuffers.Builder, scenarioIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, scenarioIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addState(builder: flatbuffers.Builder, state: SimulationRunState) {
    builder.addFieldInt8(3, state, SimulationRunState.PENDING);
  }

  static addStartedAt(builder: flatbuffers.Builder, startedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, startedAtOffset, 0);
  }

  static addStoppedAt(builder: flatbuffers.Builder, stoppedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, stoppedAtOffset, 0);
  }

  static addStartedBy(builder: flatbuffers.Builder, startedByOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, startedByOffset, 0);
  }

  static addTunnelConnected(builder: flatbuffers.Builder, tunnelConnected: boolean) {
    builder.addFieldInt8(7, +tunnelConnected, +false);
  }

  static addBanks(builder: flatbuffers.Builder, banksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, banksOffset, 0);
  }

  static createBanksVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBanksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addLastError(builder: flatbuffers.Builder, lastErrorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, lastErrorOffset, 0);
  }

  static endSimulationRun(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): SimulationRunT {
    return new SimulationRunT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.scenarioId() !== null ? this.scenarioId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.state(),
      this.startedAt(),
      this.stoppedAt(),
      this.startedBy(),
      this.tunnelConnected(),
      this.bb!.createObjList<SimulationBankStatus, SimulationBankStatusT>(
        this.banks.bind(this),
        this.banksLength(),
      ),
      this.lastError(),
    );
  }

  unpackTo(_o: SimulationRunT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.scenarioId = this.scenarioId() !== null ? this.scenarioId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.state = this.state();
    _o.startedAt = this.startedAt();
    _o.stoppedAt = this.stoppedAt();
    _o.startedBy = this.startedBy();
    _o.tunnelConnected = this.tunnelConnected();
    _o.banks = this.bb!.createObjList<SimulationBankStatus, SimulationBankStatusT>(
      this.banks.bind(this),
      this.banksLength(),
    );
    _o.lastError = this.lastError();
  }

  unpackFields(...fields: string[]): SimulationRunT {
    const t = new SimulationRunT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("scenario_id")) {
      t.scenarioId = this.scenarioId() !== null ? this.scenarioId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("state")) {
      t.state = this.state();
    }
    if (fieldSet.has("started_at")) {
      t.startedAt = this.startedAt();
    }
    if (fieldSet.has("stopped_at")) {
      t.stoppedAt = this.stoppedAt();
    }
    if (fieldSet.has("started_by")) {
      t.startedBy = this.startedBy();
    }
    if (fieldSet.has("tunnel_connected")) {
      t.tunnelConnected = this.tunnelConnected();
    }
    if (fieldSet.has("banks")) {
      t.banks = this.bb!.createObjList<SimulationBankStatus, SimulationBankStatusT>(
        this.banks.bind(this),
        this.banksLength(),
      );
    }
    if (fieldSet.has("last_error")) {
      t.lastError = this.lastError();
    }
    return t;
  }
}

export class SimulationRunT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public scenarioId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public state: SimulationRunState = SimulationRunState.PENDING,
    public startedAt: string | Uint8Array | null = null,
    public stoppedAt: string | Uint8Array | null = null,
    public startedBy: string | Uint8Array | null = null,
    public tunnelConnected: boolean = false,
    public banks: SimulationBankStatusT[] = [],
    public lastError: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const scenarioId = this.scenarioId !== null ? this.scenarioId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const startedAt = this.startedAt !== null ? builder.createString(this.startedAt!) : 0;
    const stoppedAt = this.stoppedAt !== null ? builder.createString(this.stoppedAt!) : 0;
    const startedBy = this.startedBy !== null ? builder.createString(this.startedBy!) : 0;
    const banks = SimulationRun.createBanksVector(
      builder,
      builder.createObjectOffsetList(this.banks),
    );
    const lastError = this.lastError !== null ? builder.createString(this.lastError!) : 0;

    SimulationRun.startSimulationRun(builder);
    SimulationRun.addId(builder, id);
    SimulationRun.addScenarioId(builder, scenarioId);
    SimulationRun.addOrganizationId(builder, organizationId);
    SimulationRun.addState(builder, this.state);
    SimulationRun.addStartedAt(builder, startedAt);
    SimulationRun.addStoppedAt(builder, stoppedAt);
    SimulationRun.addStartedBy(builder, startedBy);
    SimulationRun.addTunnelConnected(builder, this.tunnelConnected);
    SimulationRun.addBanks(builder, banks);
    SimulationRun.addLastError(builder, lastError);

    return SimulationRun.endSimulationRun(builder);
  }

  clone(): SimulationRunT {
    const obj = new SimulationRunT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.scenarioId = this.scenarioId !== null ? this.scenarioId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.state = this.state;
    obj.startedAt = this.startedAt;
    obj.stoppedAt = this.stoppedAt;
    obj.startedBy = this.startedBy;
    obj.tunnelConnected = this.tunnelConnected;
    obj.banks = this.banks.map((e) => e.clone());
    obj.lastError = this.lastError;
    return obj;
  }

  equals(other: SimulationRunT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.scenarioId !== null && other.scenarioId !== null) {
      if (!this.scenarioId!.equals(other.scenarioId!)) return false;
    } else if (this.scenarioId !== other.scenarioId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.state !== other.state) return false;
    if (this.startedAt !== other.startedAt) return false;
    if (this.stoppedAt !== other.stoppedAt) return false;
    if (this.startedBy !== other.startedBy) return false;
    if (this.tunnelConnected !== other.tunnelConnected) return false;
    if (this.banks.length !== other.banks.length) return false;
    for (let i = 0; i < this.banks.length; i++) {
      const a = this.banks[i];
      const b = other.banks[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.lastError !== other.lastError) return false;
    return true;
  }
}

export function verifySimulationRun(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 18, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationBankStatus);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
